import { render } from "./sidebar.vue?vue&type=template&id=6ea4d64a&ts=true"
import script from "./sidebar.vue?vue&type=script&lang=ts"
export * from "./sidebar.vue?vue&type=script&lang=ts"

import "./sidebar.vue?vue&type=style&index=0&id=6ea4d64a&lang=css"

import exportComponent from "/Users/jdmacminim61/Workspace/golfourit_ec_system/ec-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__